import React from 'react';
import styled from 'styled-components';
import ScrollToTop from '../components/ScrollToTop';

const GalleryContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
`;

const GalleryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;
  padding: 2rem 0;
`;

const GalleryItem = styled.article`
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;

  &:hover {
    transform: translateY(-4px);
    
    .caption {
      opacity: 1;
    }
  }
`;

const Image = styled.img`
  width: 100%;
  height: 300px;
  object-fit: cover;
`;

const Caption = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 1rem;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  opacity: 0;
  transition: opacity 0.2s;
`;

const CaptionTitle = styled.h3`
  margin-bottom: 0.5rem;
  font-size: 1.2rem;
`;

const CaptionText = styled.p`
  font-size: 0.9rem;
  margin: 0;
`;

const Gallery: React.FC = () => {
  const galleryItems = [
    {
      id: 1,
      image: 'https://picsum.photos/800/600?random=1',
      title: 'Ipsum Dolor',
      description: 'Lorem ipsum dolor amet, consectetur magna etiam elit.',
    },
    {
      id: 2,
      image: 'https://picsum.photos/800/600?random=2',
      title: 'Feugiat Lorem',
      description: 'Lorem ipsum dolor amet, consectetur magna etiam elit.',
    },
    {
      id: 3,
      image: 'https://picsum.photos/800/600?random=3',
      title: 'Magna Amet',
      description: 'Lorem ipsum dolor amet, consectetur magna etiam elit.',
    },
    {
      id: 4,
      image: 'https://picsum.photos/800/600?random=4',
      title: 'Sed Tempus',
      description: 'Lorem ipsum dolor amet, consectetur magna etiam elit.',
    },
    {
      id: 5,
      image: 'https://picsum.photos/800/600?random=5',
      title: 'Ultrices Magna',
      description: 'Lorem ipsum dolor amet, consectetur magna etiam elit.',
    },
    {
      id: 6,
      image: 'https://picsum.photos/800/600?random=6',
      title: 'Sed Tempus',
      description: 'Lorem ipsum dolor amet, consectetur magna etiam elit.',
    },
  ];

  return (
    <GalleryContainer>
      <GalleryGrid>
        {galleryItems.map((item) => (
          <GalleryItem key={item.id}>
            <Image src={item.image} alt={item.title} />
            <Caption className="caption">
              <CaptionTitle>{item.title}</CaptionTitle>
              <CaptionText>{item.description}</CaptionText>
            </Caption>
          </GalleryItem>
        ))}
      </GalleryGrid>
      <ScrollToTop />
    </GalleryContainer>
  );
};

export default Gallery; 